// Persist a half-finished configurator session in the browser so shoppers can pick it up later.
const KEY = (productType) => `apollo-config-draft:${productType}`;

export const readConfigDraft = (productType) => {
  try {
    const raw = localStorage.getItem(KEY(productType));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const writeConfigDraft = (productType, draft) => {
  try {
    localStorage.setItem(KEY(productType), JSON.stringify({ ...draft, saved_at: new Date().toISOString() }));
  } catch (e) {
    /* storage full or unavailable */
  }
};

export const clearConfigDraft = (productType) => localStorage.removeItem(KEY(productType));

export const draftHasSelections = (config) => Boolean(
  config.fabric_color || config.mount_type || config.width || config.height || config.control_type ||
  config.roll_direction || config.bracket_type || config.optional_features?.length || config.room_label || config.needs_installation
);
